import { connect } from 'react-redux';
import navBar from '../components/navBar/navBar';
// import { openSideBar, closeSideBar } from '../actions/sideBar'

const mapStateToProps = (state) => ({
    
    data: state.navBarReducer
})

const mapDispatchToProps = (dispatch) => {
    return {
        // openSideBar: () => {
        //     dispatch(openSideBar())
        // },
        // closeSideBar: () => {
        //     dispatch(closeSideBar())
        // }
    }
}

const NavBar = connect(
    mapStateToProps,
    mapDispatchToProps
)(navBar)

export default NavBar;